<template>
  <div class="productionList">
    <div class="content-container">
      <!-- 头部 -->
      <div class="titieMian">
        <div class="title-container">生产计划</div>
        <div class="select-container">
          <div class="select-container-box">
            <span>时间&nbsp;&nbsp;</span>
            <el-select v-model="year" filterable placeholder="请选择"  size="small" @change="changeYear">
              <el-option
                v-for="(item, index) in yearList"
                :key="index"
                :label="item.value"
                :value="item.key">
              </el-option>
            </el-select>
          </div>
         
          <div class="select-container-box">
            <el-button size="small"  type="info" plain @click="search(1)" class="query">查询</el-button>
            <el-button size="small"  type="info" plain @click="add" class="add" v-if="isEdit">增加</el-button>
          </div>  
        </div>       
      </div>
      <!-- 列表 -->
      <div class="table-container">
        <el-table
          :row-class-name="rowClassName"
          show-summary
          :summary-method="getSummaries"
          :data="planList"
          style="width:100%"
          size="medium"
          :default-sort = "{prop: 'date', order: 'ascending'}"
         >
          <i slot="empty" style="font-style:normal">该时间段暂无数据</i>
          <el-table-column
            prop="year"
            label="时间"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <el-select v-model="scope.row.year" placeholder="">
                <el-option
                  v-for="item in yearList"
                  :key="item.id"
                  :label="item.value"
                  :value="item.key">
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column
            prop="fishBaseId"
            label="基地名称"
            align="center"
            width="150"
            show-overflow-tooltip
            >
            <template slot-scope="scope">
              <el-select v-model="scope.row.fishBaseId" placeholder=""  @change="chageBase(scope.$index,scope.row)">
                <el-option
                  v-for="item in baseList"
                  :key="item.id"
                  :label="item.value"
                  :value="item.key">
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column
            prop="fishPondId"
            label="塘口编号"
            align="center"
            width="130"
            show-overflow-tooltip
            >
            <template slot-scope="scope">
              <!-- {{pondList[scope.$index]}} -->
              <el-select v-model="scope.row.fishPondId" placeholder=""  @change="chagePond(scope.$index,scope.row)">
                <el-option
                  v-for="item in pondList[scope.$index]"
                  :key="item.id"
                  :label="item.value"
                  :value="item.key">
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column
            prop="fishCost"
            label="鱼苗(元)"
            align="center"
         >
          <template slot-scope="scope">
            <el-input v-model="scope.row.fishCost" @input="calculation(scope.$index,scope.row)" type="number" maxlength="10" placeholder=""></el-input>
          </template>
          </el-table-column>
          <el-table-column
            prop="fodderCost"
            label="饲料(元)"
            align="center"
            show-overflow-tooltip
          >
          <template slot-scope="scope">
            <el-input v-model="scope.row.fodderCost" @input="calculation(scope.$index,scope.row)" type="number" maxlength="10" placeholder=""></el-input>
          </template>
          </el-table-column>
          <el-table-column
            prop="medicineCost"
            label="鱼药(元)"
            align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.medicineCost" @input="calculation(scope.$index,scope.row)" type="number" maxlength="10" placeholder=""></el-input>
            </template>
          </el-table-column>
          <el-table-column
            prop="laborCost"
            align="center"
            label="人工费用(元)"
            width="120"
           >
            <template slot-scope="scope">
              <el-input v-model="scope.row.laborCost" @input="calculation(scope.$index,scope.row)" type="number" maxlength="10" placeholder=""></el-input>
            </template>
          </el-table-column>
          <el-table-column
            prop="waterElectricityCost"
            label="水电费用(元)"
            width="120"
            align="center"
          >
            <template slot-scope="scope">
              <el-input v-model="scope.row.waterElectricityCost" @input="calculation(scope.$index,scope.row)" type="number" maxlength="10" placeholder=""></el-input>
            </template>
          </el-table-column>
          <el-table-column
            prop="equipmentCost"
            label="设备费用(元)"
            width="120"
            align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.equipmentCost" @input="calculation(scope.$index,scope.row)" type="number" maxlength="10" placeholder=""></el-input>
            </template>
          </el-table-column>
          <el-table-column
            prop="pondRent"
            label="池塘租金(元)"
            width="120"
            align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.pondRent" @input="calculation(scope.$index,scope.row)" type="number" maxlength="10" placeholder=""></el-input>
            </template>
          </el-table-column>
          <el-table-column
            prop="orterCost"
            label="其他费用(元)"
            width="120"
            align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.orterCost" @input="calculation(scope.$index,scope.row)" type="number" maxlength="10" placeholder=""></el-input>
            </template>
          </el-table-column>
           <el-table-column
            prop="total"
            label="总额(元)"
            align="center">
          </el-table-column>
          <el-table-column label="操作栏" align="center" width="120" v-if="isEdit">
            <template slot-scope="scope">
              <span
                class="content-edit"
                @click="handleEdit(scope.$index, scope.row)">{{scope.row.edit}}</span>
              <span
                class="content-del"
                @click="handleDelete(scope.$index, scope.row)" >删除</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <page-change :pageInfo="pageInfo"></page-change>
      <!-- <p class="pagination-info" v-if="productionList.length">显示第 1 到第 {{productionList.length}} 条记录 , 总共 {{productionList.length}} 条记录</p> -->
    </div>
  </div>
</template>

<script>
import PageChange from "../../common/PageChange";
import { MessageBox, Message } from "element-ui";
import { mapState, mapActions } from "vuex";
import { modules } from "../../../store";
import { storage } from "../../../service/storage";
import checkPermission from "../../../service/checkPermission.js";
import mixins from "@/common/MixIn.js";
export default {
  name: "productionPlan",
  mixins: [mixins],
  components: {
    PageChange
  },
  data() {
    return {
      once: true, //是否第一次添加
      num10: 3,
      isEdit: "",
      year: new Date().getFullYear(),
      edit: "编辑",
      // 年份
      yearList: [
        { key: 2014, value: "2014" },
        { key: 2015, value: "2015" },
        { key: 2016, value: "2016" },
        { key: 2017, value: "2017" },
        { key: 2018, value: "2018" },
        { key: 2019, value: "2019" },
        { key: 2020, value: "2020" },
        { key: 2021, value: "2021" }
      ],
      // 分页
      pageInfo: {
        pageNumber: 1, // 当前页数
        totalPages: 0, // 总页数
        pageFunc: this.search, // 当前页数需要调用的函数
        pageSize: 10 // 当前页数
      },
      // 列表数据
      productionList: [],
      baseList: [], //基地列表
      pondList: [] // 塘口列表
    };
  },
  computed: {
    planList() {
      return this.productionList.map(item => {
        if (!item.edit) {
          item.edit = "编辑";
          item.total = this.countTotal(item);
          item.baseList = this.baseList;
          // item.pondList = [];
        }
        return item;
      });
    }
  },
  async mounted() {
    if (
      this.companyList.isQlwVersion == false ||
      this.companyList.isQlwVersion == null
    ) {
      let permission = this.loginUser.permissions.find(item => {
        return item.permissionId == this.permission.productPlan;
      });
      if (permission) {
        this.isEdit = !permission.isReadOnly;
      }
    } else if (this.companyList.isQlwVersion == true) {
      checkPermission.checkEdit(this.$route).then(data => {
        console.log("生产计划", data);

        this.isEdit = data;
      });
    }
    this.init();
    this.baseList = await this.getBaseList();
  },
  methods: {
    ...mapActions(modules.productionPlan, [
      "getProductionList", //查询数据
      "delProductionList",
      "addProductionList",
      "editProductionList"
    ]),
    ...mapActions(modules.base, {
      getBaseList: "getBaseList" //基地
    }),
    ...mapActions(modules.pond, {
      getFishPond: "getFishPond" //塘口
    }),
    async init() {
      this.productionList = await this.getProductionList({
        Year: this.year,
        PageIndex: this.pageInfo.pageNumber,
        PageSize: this.pageInfo.pageSize
      });
      this.pageInfo.totalPages = this.productionList.length;
      this.productionList.forEach(async (item, index) => {
        console.log(item);
        if (item.fishPondId == null) {
          item.fishPondId = "全部";
        }
        let list = await this.getFishPond(item.fishBaseId);
        this.$set(this.pondList, index, list); // 获取初始化塘口列表   利用索引直接设置一个项时(无效) 使用set
      });
    },
    //添加
    async add() {
      if (this.once) {
        this.productionList.unshift({
          year: this.year,
          // fishBaseId: "",
          // fishPondId: "",
          fishCost: 0,
          fodderCost: 0,
          medicineCost: 0,
          laborCost: 0,
          waterElectricityCost: 0,
          equipmentCost: 0,
          pondRent: 0,
          orterCost: 0,
          edit: "保存",
          total: 0
        });
        // 添加塘口列表
        this.baseList = await this.getBaseList();
        this.pondList.unshift([]);
        this.once = false;
      } else {
        this.$Alert.info({
          content: "每次只能添加一条记录，请先保存",
          duration: 5000,
          status: "error"
        });
        // Message.error("每次只能添加一条记录，请先保存");
      }
    },
    // 切换年份查询
    changeYear(e) {
      this.search();
      this.once = true;
    },
    // 切换基地
    async chageBase(index, row) {
      console.log(index, row.fishPondId);
      let kk = await this.getFishPond(row.fishBaseId);
      kk = [
        {
          key: "",
          value: "全部"
        }
      ].concat(kk);
      this.$set(this.pondList, index, kk);
      if (kk.length == 0) {
        this.$Alert.info({
          content: "该基地下无塘口",
          duration: 5000,
          status: "error"
        });
        // Message.error("该基地下无塘口");
        this.productionList[index].fishPondId = "";
      } else {
        this.productionList[index].fishPondId = this.pondList[index][0].key;
        this.$set(this.productionList, index, {
          id: row.id,
          year: row.year,
          fishBaseId: row.fishBaseId,
          fishPondId:
            row.fishPondId == null || row.fishPondId == "全部"
              ? ""
              : row.fishPondId,
          fishCost: row.fishCost,
          fodderCost: row.fodderCost,
          medicineCost: row.medicineCost,
          laborCost: row.laborCost,
          waterElectricityCost: row.waterElectricityCost,
          equipmentCost: row.equipmentCost,
          pondRent: row.pondRent,
          orterCost: row.orterCost,
          edit: "保存",
          total: this.countTotal(row)
        });
      }
    },
    // 切换塘口
    chagePond(index, row) {
      // console.log(row);

      console.log(index, row);
    },
    // 动态设置行的类名
    rowClassName(row) {
      if (row.row.edit == "编辑") {
        return "";
      } else {
        return "row-disabled";
      }
    },
    // 合计行自定义文字显示
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        if (index === 1) {
          sums[index] = "";
          return;
        }
        if (index === 2) {
          sums[index] = "";
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] += "";
        } else {
          sums[index] = "";
        }
      });

      return sums;
    },
    // 表格输入自动求和
    calculation(index, row) {
      this.$set(this.productionList, index, {
        id: row.id,
        year: row.year,
        fishBaseId: row.fishBaseId,
        fishPondId:
          row.fishPondId == null || row.fishPondId == "全部"
            ? ""
            : row.fishPondId,
        fishCost: row.fishCost,
        fodderCost: row.fodderCost,
        medicineCost: row.medicineCost,
        laborCost: row.laborCost,
        waterElectricityCost: row.waterElectricityCost,
        equipmentCost: row.equipmentCost,
        pondRent: row.pondRent,
        orterCost: row.orterCost,
        edit: "保存",
        total: this.countTotal(row)
      });
    },
    // 计算每一行的总数
    countTotal(item) {
      return (
        parseInt(item.fishCost) +
        parseInt(item.fodderCost) +
        parseInt(item.medicineCost) +
        parseInt(item.laborCost) +
        parseInt(item.waterElectricityCost) +
        parseInt(item.equipmentCost) +
        parseInt(item.pondRent) +
        parseInt(item.orterCost)
      );
    },
    addProductionPlan(index, row) {
      this.$set(this.productionList, index, {
        id: row.id,
        year: row.year,
        fishBaseId: row.fishBaseId,
        fishPondId:
          row.fishPondId == null || row.fishPondId == "全部"
            ? ""
            : row.fishPondId,
        fishCost: row.fishCost,
        fodderCost: row.fodderCost,
        medicineCost: row.medicineCost,
        laborCost: row.laborCost,
        waterElectricityCost: row.waterElectricityCost,
        equipmentCost: row.equipmentCost,
        pondRent: row.pondRent,
        orterCost: row.orterCost,
        edit: "编辑",
        total: this.countTotal(row)
      });
      this.addProductionList(row)
        .then(async data => {
          this.$message.success("保存成功");
          this.once = true;
          this.init();
        })
        .catch(err => {
          // console.log(err);
          this.$Alert.info({
            content: err.response.data,
            duration: 5000,
            status: "error"
          });
          // this.$message.error("添加失败");
        });
    },
    editProductionPlan(index, row) {
      this.editProductionList(row)
        .then(async data => {
          this.once = true;
          this.$message.success("保存成功");
          // this.init();
          this.productionList.splice(index, 1, {
            id: row.id,
            year: row.year,
            fishBaseId: row.fishBaseId,
            fishPondId:
              row.fishPondId == null || row.fishPondId == "全部"
                ? ""
                : row.fishPondId,
            fishCost: row.fishCost,
            fodderCost: row.fodderCost,
            medicineCost: row.medicineCost,
            laborCost: row.laborCost,
            waterElectricityCost: row.waterElectricityCost,
            equipmentCost: row.equipmentCost,
            pondRent: row.pondRent,
            orterCost: row.orterCost,
            edit: "编辑",
            total: this.countTotal(row)
          });
        })
        .catch(err => {
          this.$Alert.info({
            content: err.response.data,
            duration: 5000,
            status: "error"
          });
          // this.$message.error("修改失败");
        });
    },
    //编辑
    async handleEdit(index, row) {
      switch (row.edit) {
        case "保存":
          if (!row.id) {
            if (!row.fishBaseId || row.fishBaseId == "") {
              this.$message.error("请选择基地名称");
              return;
            }
            this.addProductionPlan(index, row);
          } else {
            this.editProductionPlan(index, row);
          }

          break;
        case "编辑":
          this.chageBase(index, row);
          this.$set(this.productionList, index, {
            id: row.id,
            year: row.year,
            fishBaseId: row.fishBaseId,
            fishPondId:
              row.fishPondId == null || row.fishPondId == "全部"
                ? ""
                : row.fishPondId,
            fishCost: row.fishCost,
            fodderCost: row.fodderCost,
            medicineCost: row.medicineCost,
            laborCost: row.laborCost,
            waterElectricityCost: row.waterElectricityCost,
            equipmentCost: row.equipmentCost,
            pondRent: row.pondRent,
            orterCost: row.orterCost,
            edit: "保存",
            total: this.countTotal(row)
          });
          this.$forceUpdate();
          break;
      }
    },
    // 删除
    handleDelete(index, row) {
      this.$confirm("是否删除此记录", "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        if (row.id) {
          this.delProductionList(row.id)
            .then(data => {
              this.productionList.splice(index, 1);
              this.pondList.splice(index, 1);
              this.$message.success("删除成功");
            })
            .catch(err => {
              this.$Alert.info({
                content: err.response.data,
                duration: 5000,
                status: "error"
              });
              // this.$message.error("删除失败");
            });
        } else {
          this.productionList.splice(index, 1);
          this.pondList.splice(index, 1);
          this.once = true;
        }
      });
    },
    //查询数据
    async search(pageNum) {
      // this.productionList = await this.getProductionList({
      //   Year: this.year,
      //   PageIndex: this.pageInfo.pageNumber,
      //   PageSize: this.pageInfo.pageSize
      // });
      // this.pageInfo.totalPages = this.productionList.length;

      this.productionList = await this.getProductionList({
        Year: this.year,
        PageIndex: this.pageInfo.pageNumber,
        PageSize: this.pageInfo.pageSize
      });
      this.pageInfo.totalPages = this.productionList.length;
      this.productionList.forEach(async (item, index) => {
        if (item.fishPondId == null) {
          item.fishPondId = "全部";
        }
        let list = await this.getFishPond(item.fishBaseId);
        this.$set(this.pondList, index, list); // 获取初始化塘口列表   利用索引直接设置一个项时(无效) 使用set
      });
    }
  }
};
</script>
<style lang="stylus">
.productionList
  .el-tooltip
    input
      text-overflow: ellipsis;
      padding-right: 10px;
      overflow: hidden;
  .pagination-info
    margin-top:5px;
    margin-left:20px;
    line-height:40px;
    font-size:14px;
    color:#333;
  //去除type=number 输入款上下箭头
  input[type=number] {  
    -moz-appearance:textfield;  
  }  
  input[type=number]::-webkit-inner-spin-button,  
  input[type=number]::-webkit-outer-spin-button {  
      -webkit-appearance: none;  
      margin: 0;  
  }  
  .content-edit,.content-del
    pointer-events:auto
  .el-table tr:hover>td 
    background:none !important;
  .cell
    text-align:center;
    input
      text-align:center;
      
    .el-input__suffix-inner
      pointer-events:none
      cursor: not-allowed
  td
    pointer-events:none
    cursor: not-allowed
    .el-input__inner
      border:none
  
  .table-container
    .el-icon-arrow-up:before
      content: "";
    .el-input__inner
      background:initial;
      padding-right:0;
      padding-left:0;
  // 添加 row-disabled
  .row-disabled
    .el-icon-arrow-up:before
      content: "\E605"!important;
    td
      pointer-events:auto
      cursor: not-allowed
    .el-input__inner
      border:1px solid #ddd;
    .el-input--suffix
      .el-input__inner
        border:1px solid #ddd;
        padding-right:30px;
        padding-left:10px;
    
</style>
